export enum ProductTypes {
  NONE = 0,
  GLASS = 1,
  PVC_PANEL = 2,
  SLAB = 3,
  SLAB_CASSETTE = 4,
  PVC_BAY = 201,
  PVC_BOW = 202,
  PVC_COUPLED = 211
}

export enum ProductType {
  NONE = 0,
  SERVER = 1,
  SERVER_ACCESS_SERVER = 2,
  SERVER_ACCESS_VENDOR = 3,
  SERVER_ACCESS_DEVELOPER = 4,
  BUSINESS = 5,
  PORTAL = 6,
  DEALER = 7,
  ECOMMERCE = 8,
  FACTORY = 9,
  VENDOR = 10,
  VENDOR_LINK = 11,
  COURIER = 12,
  REGISTER = 13,
  SUPPORT = 14,
  HOSTING = 15,
  DATA_BUILD = 16,
  VENDOR_USER = 17,
  COURIER_USER = 18,
  BRANDED_LINK = 19,
  BRANDED = 20,
  CONNECT_COMPONENT_PORTAL = 21,
  CONNECT_COMPONENT_ADMIN = 22,
  CONNECT_PRODUCT_VENDOR = 23,
  CONNECT_PRODUCT_ADMIN = 24,
  RACKMANAGER = 25,
  INTEGRATE = 26,
  BRANCHES = 27,
  PAYMENT_GATEWAY = 28,
  STOCK_PARTS = 30,
  EXTRUDER = 33
}

export enum ProductStatus {
  NONE = 0,
  INACTIVE = 1,
  LEAD_GEN_ONLY = 2,
  ACTIVE = 3
}

export enum FinancialType {
  COST = 0,
  PRICE = 1
}

export enum PriceRateType {
  NONE = 0,
  EACH = 1,
  METER_SQUARED = 2,
  PER_METER = 3,
  PERCENT = 4,
  PER_KG = 5
}

export enum AnomalyType {
  SIMPLE_VALUE = 0,
  LIST = 1,
  GRID = 2
}

export enum DiscountLimitTo {
  NONE = 0,
  LIMITED_TO_SPECIFIC_CUSTOMERS = 1
}

export enum DiscountType {
  PERCENTAGE = 0,
  FIXED = 1
}

export enum DiscountPerOrderOrItem {
  ORDER = 0,
  ITEM = 1
}

export enum DiscountStatus {
  DISABLED = 0,
  ENABLED = 1,
  EXPIRED = 2,
  REDEEMED = 3
}

export enum UnitOfMeasure {
  NONE = 0,
  UNIT = 1,
  LENGTH = 2,
  WIDTH = 3,
  HEIGHT = 4,
  AREA = 5,
  PERIMETER = 6,
  VOLUME = 7,
  FITTING_DAYS = 8
}

export enum IssueSeverity {
  INFORM = 0,
  WARN = 1,
  RESTRICT = 2,
  PROHIBIT = 3
}

export const IssueSeverityLabel = {
  INFORM: 'Inform',
  WARN: 'Warn',
  RESTRICT: 'Restrict',
  PROHIBIT: 'Prohibit'
} as const

export type IssueSeverityLabel = (typeof IssueSeverityLabel)[keyof typeof IssueSeverityLabel]

export enum OptionSetByTypes {
  DEFAULT = 0,
  AUTOMATION = 1,
  USER = 2,
  CLONED = 3,
  PREVIOUS_SELECTION_INVALIDATED = 4
}

export enum VisibilityType {
  STANDARD = 0,
  ONLY_FOR_DESIGN_SELECTION = 1
}

export const ImageType = {
  EXTERNAL: { id: 1, label: 'External' },
  INTERNAL: { id: 2, label: 'Internal' },
  PLAN: { id: 3, label: 'Bow/Bay Plan' },
  GLASS_SCHEMATIC: { id: 4, label: 'Schematic' },
  FOLDING_SASH_VIEW: { id: 5, label: 'Folding Sash Plan' },
  SASH_PLAN_VIEW: { id: 6, label: 'Sash Plan' }
} as const

export type ImageType = (typeof ImageType)[keyof typeof ImageType]

export const ImageTypeById = Object.fromEntries(Object.values(ImageType).map((type) => [type.id, type])) as Record<
  ImageType['id'],
  ImageType
>

export enum SubscriptionBehaviourTypes {
  NULL = -1,
  DISABLED = 0,
  MANDATORY = 1,
  ENABLED = 2,
  PENDING = 3
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export enum ExtraType {
  NONE = 0,
  NON_STOCK_EXTRA = 1,
  FREE_TYPED_EXTRA = 2,
  STOCK_EXTRA = 3
}
